import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, MenuItem, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, TextField, Select, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Typography, FormHelperText } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { GROCERY_ITEM } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import EditPenIcon from "src/svgComponents/EditPenIcon";
import BinIcon from "src/svgComponents/BinIcon";
import CloseIcon from '@mui/icons-material/Close';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from '@mui/material/styles';
import { useMutation } from "react-query";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import useStore from 'src/contexts/AuthProvider';
import ShowImage from "../common/ShowImage";
import moment from "moment";
import AppTooltip from "src/components/common/AppTooltip";
import DefaultImage from "../../assets/images/food_default_image.png";
import { LoadingButton } from '@mui/lab';
import ButtonText from "src/components/common/ButtonText";

const _ = require('lodash');

const GroceryItem = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [filterName, setFilterName] = useState('');
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const axiosPrivate = useAxiosPrivate();
   const [openModal, setOpenModal] = useState(false);
   const [foodCategory, setFoodCategory] = useState();
   const [profilePic, setProfilePic] = useState("");
   const [selectCategoryId, setSelectCategoryId] = useState();
   const [selectMenuId, setSelectMenuId] = useState();
   const [imageName, setImageName] = useState();
   const [showImage, setShowImage] = useState();
   const [groceryMenuData, setGroceryMenuData] = useState();
   const [modelTitle, setmodelTitle] = useState("");
   const [parentId, setParentId] = useState('');
   const [disable, setDisable] = useState(false);
   const [Id, setId] = useState("");
   const { enqueueSnackbar } = useSnackbar();
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const theme = useTheme();
   const [loading, setLoding] = useState(true);
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const permissionsData = useStore(state => state.permissions);
   const [uploadedImage, setUploadedImage] = useState();
   const [flag, setFlag] = useState();
   const [buttonLoading, setButtonLoding] = useState(false);

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'name', label: 'Grocery Name', alignRight: false },
      { id: 'image', label: 'Grocery Photo', alignRight: false },
      { id: 'description', label: 'Description', alignRight: false },
      { id: 'quantity', label: 'Quantity', alignRight: false },
      { id: 'price', label: 'MRP', alignRight: false },
      { id: 'discount', label: 'Discount', alignRight: false },
      { id: 'offerPrice', label: 'Offer Price', alignRight: false },
      { id: 'category name', label: 'From Category', alignRight: false },
      { id: 'menu name', label: 'From Menu', alignRight: false },
      { id: 'created', label: 'Dated On', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   async function getGroceryItems(page, filterName) {
      const response = await axiosPrivate.get(GROCERY_ITEM.getGoceryItems, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: groceryItemList, refetch } = useQuery(['groceryItemList', page, filterName], () => getGroceryItems(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (groceryItemList) {
         setTableData(groceryItemList.data);
         setRowsPerPage(groceryItemList?.metadata.length !== 0 ? groceryItemList?.metadata[0].limit : 10);
      }
      if (groceryItemList?.metadata.length !== 0 && groceryItemList?.metadata[0].hasMoreData === true) {
         getGroceryItems(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)
   }, [groceryItemList])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getGroceryItems(page, filterName)
      refetch();
   };

   async function getGroceryCategory() {
      const response = await axiosPrivate.get(GROCERY_ITEM.getGroceryCategoryList, { params: { page: 1 } })
      return response.data;
   }
   const { data: groceryList } = useQuery(['groceryList'], () => getGroceryCategory(), { keepPreviousData: true, })
   useEffect(() => {
      if (groceryList !== undefined) {
         setFoodCategory(groceryList)
      }
   }, [groceryList])

   async function getGroceryMenu() {
      const response = await axiosPrivate.get(GROCERY_ITEM.getGrocerymenuList)
      return response.data;
   }
   const { data: groceryMenuList } = useQuery(['groceryMenuList'], () => getGroceryMenu(), { keepPreviousData: true, })
   useEffect(() => {
      if (groceryMenuList !== undefined) {
         setGroceryMenuData(groceryMenuList)
      }
   }, [groceryMenuList])

   const completedSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, "Name can set of between 2 and 50 characters!")
         .max(50, "Name can set of between 2 and 50 characters!")
         .required("Name is required"),
      price: Yup.number()
         .required('Price is required')
         .min(1, "Price must be greater than 1"),
      // .max(99999, "Price must be less than 99999"),
      offerPrice: Yup.number()
         .required('Offer price is required')
         .min(1, "Offer price must be greater than 1"),
      // .max(99999, "Offer price must be less than 99999"),
      quantity: Yup.number()
         .required('Quantity is required')
         .min(1, "Quantity must be greater than 1")
         .max(99999, "Quantity must be less than 99999"),
      description: Yup.string().required('Description is required'),
      grocery_category_id: Yup.string().required('Grocery Category is required'),
      grocery_menu_id: Yup.string().required('Grocery Menu is required')
   });

   const handleUploadImage = async () => {
      const formData = new FormData();
      formData.append('image', uploadedImage)
      const imageData = await axiosPrivate
         .post(GROCERY_ITEM.uploadImage, formData)
         .catch((e) => {
            setButtonLoding(false);
            enqueueSnackbar(e?.response?.data?.message, {
               variant: "error",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
         });
      setImageName(imageData?.data?.file_name)
      setFieldValue("image", imageData?.data?.file_name)
      return imageData?.data?.file_name;
   }

   const formik = useFormik({
      initialValues: {
         grocery_category_id: "",
         grocery_menu_id: "",
         name: "",
         price: "",
         discount: "",
         offerPrice: "",
         quantity: "",
         description: "",
         image: ""
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         let image_name = '';
         if (!imageName) {
            if (flag === 'asd') {
               image_name = await handleUploadImage();
            }
         } else {
            image_name = imageName
         }
         if (image_name) {
            setButtonLoding(true)
         }
         const informationObj = {
            name: values.name.trim(),
            price: values.price,
            discount: values.discount,
            offerPrice: values.offerPrice,
            quantity: values.quantity,
            description: values.description,
            image: image_name
         };
         if (selectCategoryId) {
            informationObj.grocery_category_id = selectCategoryId;
         }
         if (selectMenuId) {
            informationObj.grocery_menu_id = selectMenuId;
         }
         if (Id === "") {
            await groceryAdd(informationObj);
         } else {
            await groceryItemUpdate(informationObj);
         }
         setParentId("");
         resetForm();
         setSubmitting(false);
      },
   });

   const { mutateAsync: groceryAdd } = useMutation(
      async (data) => {
         return await axiosPrivate.post(GROCERY_ITEM.addGrocery, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar("Item add successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            refetch();
            setButtonLoding(false);
         },
         onError: (error) => {
            setButtonLoding(false);
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else if (key === "grocery_category_id") {
                  setFieldError("grocery_category_id", errorData[key]);
               } else if (key === "image") {
                  setFieldError("image", errorData[key]);
               } else if (key === "grocery_menu_id") {
                  setFieldError("grocery_menu_id", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   const { mutateAsync: groceryItemUpdate } = useMutation(
      async (data) => {
         return await axiosPrivate.put(GROCERY_ITEM.updateGrocery + Id, data)
      },
      {
         onSuccess: ({ data }) => {
            refetch();
            enqueueSnackbar("Item update successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            setButtonLoding(false);
         },
         onError: (error) => {
            setButtonLoding(false);
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
      setShowImage('');
   };

   const deleteGroceryItem = async () => {
      const response = await axiosPrivate.delete(GROCERY_ITEM.deleteGrocery + deleteId)
      if (response.status === 200) {
         enqueueSnackbar("Item deleted successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const handleOpenModalAdd = () => {
      setFieldValue('name', "")
      setFieldValue('price', "")
      setFieldValue('description', "")
      setFieldValue('quantity', "")
      setSelectCategoryId('');
      setSelectMenuId('');
      setImageName('');
      setShowImage('');
      setProfilePic('');
      setFlag('')
      setId('')
      setmodelTitle('Grocery Item Add')
      setFieldValue('price', "")
      setFieldValue('discount', "")
      setFieldValue('offerPrice', "")
      setDisable(false);
      setOpenModal(true);
   };

   const handleOpenModalUpdate = (row) => {
      if (row.discount === undefined) {
         setFieldValue('offerPrice', row.price)
      } else {
         setFieldValue('offerPrice', row.offerPrice)
      }
      setImageName(row.image)
      setProfilePic('')
      setFieldValue('name', row.name)
      setFieldValue('price', row.price)
      setFieldValue('discount', row.discount)
      setFieldValue('quantity', row.quantity)
      setFieldValue('description', row.description)
      setFieldValue('grocery_category_id', row?.grocery_category_data?._id)
      setFieldValue('grocery_menu_id', row?.grocery_menu_data?._id)
      setShowImage(row.image)
      setSelectCategoryId(row?.grocery_category_data?._id)
      setSelectMenuId(row?.grocery_menu_data?._id)
      setId(row._id)
      setmodelTitle('Grocery Item Update')
      setDisable(true);
      setOpenModal(true);
   };

   const handleClickOpen = (categoryId, categoryType) => {
      setdeleteId(categoryId);
      setOpen(true);
   };

   const handleCloseModal = () => {
      setOpenModal(false);
      resetForm();
   };

   const handleProfilePicOnChange = async (ev) => {
      if (ev.type.includes("image")) {
         setUploadedImage(ev);
         let userImgSrc = URL.createObjectURL(ev);
         setProfilePic(userImgSrc);
         setImageName('')
      } else {
         enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
   };

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched, resetForm } = formik;

   const changeStatus = async (id) => {
      const response = await axiosPrivate.put(GROCERY_ITEM.changeGroceryItemStatus + id)
      if (response?.data?.message) {
         enqueueSnackbar(response?.data?.message, {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch()
   }

   const handleFoodCategoryOnChange = (event) => {
      setSelectCategoryId(event.target.value);
   };

   const handleFoodMenuOnChange = (event) => {
      setSelectMenuId(event.target.value);
   };
   const setDiscount = (e) => {
      let price = getFieldProps("price");
      let discount = e.target.value;
      setFieldValue('discount', discount)
      let discountInRs = price.value * discount / 100;
      let offerPrice = price.value - discountInRs;
      setFieldValue('offerPrice', offerPrice)
   }

   const setPrice = (e) => {
      let discount = getFieldProps("discount");
      let price = e.target.value;
      setFieldValue('price', price)
      let discountInRs = price * discount.value / 100;
      let offerPrice = price - discountInRs;
      if (discount.value) {
         setFieldValue('offerPrice', offerPrice)
      } else {
         setFieldValue('offerPrice', price)
      }
   }

   const removeImage = () => {
      setProfilePic('');
      setImageName('');
      setShowImage('');
   }

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Grocery Items</h4>
            <Box className="d-flex align-items-center">
               <Paper component="form" className='dashboard_searchbox' sx={{ minWidth: '380px' }}>
                  <IconButton>
                     <SearchIcon />
                  </IconButton>
                  <InputBase
                     fullWidth
                     sx={{ flex: 1 }}
                     placeholder="search grocery..."
                     onChange={(e) => handleFilterByName(e)}
                     onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                  />
               </Paper>
               <Stack direction={"row"} className="d-flex align-items-center ms-lg-4 ms-2" spacing={2}>
                  {permissionsData?.grocery_items?.substring(1, 2) == "1" ?
                     <AppTooltip title="Add Grocery" placement="bottom">
                        <ButtonText text={'Add Item'} onClickBtn={() => handleOpenModalAdd()} />
                     </AppTooltip> : ""}
               </Stack>
            </Box>
         </div>
         <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
            </DialogContent>
            <DialogActions className='m-auto'>
               <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                  cancel
               </Button>
               <Button className="theme_button" variant="contained" onClick={() => deleteGroceryItem()} autoFocus>
                  delete
               </Button>
            </DialogActions>
         </Dialog>
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={groceryItemList?.data?.length}
                     onRequestSort={handleRequestSort}
                  />
                  {filteredUsers.length > 0 ?
                     <TableBody>
                        {filteredUsers.map((row) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell component="th" scope="row"> <span className="d-flex text-nowrap">{row.name}</span> </TableCell>
                                 <TableCell component="th" scope="row">
                                    <img src={row.image ? process.env.REACT_APP_PROFILE_URL + 'groceryItem/' + row.image : DefaultImage} height="53px" width="73px" alt="profile" />
                                 </TableCell>
                                 <TableCell align="left" style={{ width: '340px', wordBreak: 'break-word' }} component="th"> {row?.description?.substring(0, 38) + (row?.description.length >= 38 ? ' ....' : '')}</TableCell>
                                 <TableCell align="left"> {row.quantity ?? '-'}</TableCell>
                                 <TableCell align="left"> £{row.price?.toFixed(2) ?? '0.00'}</TableCell>
                                 <TableCell align="left"> {row.discount ? row.discount + '%' : '0.00'}</TableCell>
                                 <TableCell align="left"> £{row.offerPrice.toFixed(2) ?? '-'}</TableCell>
                                 <TableCell align="left"> {row.grocery_category_data && row.grocery_category_data?.name}</TableCell>
                                 <TableCell align="left"> {row.grocery_menu_data && row.grocery_menu_data.name}</TableCell>
                                 <TableCell align="left" style={{ width: '300px' }}><span className="d-flex text-nowrap">{moment(row.createdAt).format("DD MMM YYYY h:mm A")}</span></TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {
                                          row.status === 1 ? <Chip variant="contained" label="Enable" className="app_status_chip accepted" onClick={() => changeStatus(row._id)} /> : <Chip variant="contained" className="app_status_chip invalid" label="Disable" onClick={() => changeStatus(row._id)} />
                                       }
                                    </Stack>
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {permissionsData?.grocery_items?.substring(3, 4) == "1" ?
                                          <AppTooltip title="Edit" placement="bottom">
                                             <Button sx={{ "&:hover": { bgcolor: "transparent" } }} onClick={() => handleOpenModalUpdate(row)} variant="text" className="user_list_row_btn" ><EditPenIcon /></Button>
                                          </AppTooltip> : ""}
                                       {permissionsData?.grocery_items?.substring(2, 3) == "1" ?
                                          <AppTooltip title="Delete" placement="bottom">
                                             <Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                          </AppTooltip> : ""}
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                        {/* {emptyRows > 0 && (
                           <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                           </TableRow>
                        )} */}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={8} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">No Data Found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}
               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={groceryItemList?.metadata.length !== 0 ? groceryItemList?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>
         <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
         >
            <DialogTitle>
               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h4>{modelTitle}</h4>
                  <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                     <CloseIcon style={{ color: '#fff' }} />
                  </Button>
               </Box>
            </DialogTitle>
            <DialogContent className="custom_form_mui pt-2">
               <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                     <div className="row">
                        <div className="col-lg-6">
                           <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">From Category</InputLabel>
                              <Select
                                 labelId="demo-simple-select-label"
                                 id="grocery_category_id"
                                 name="grocery_category_id"
                                 label="From Category"
                                 value={selectCategoryId}
                                 onChange={(e) => {
                                    handleFoodCategoryOnChange(e);
                                    setFieldTouched("grocery_category_id", true)
                                    setFieldValue("grocery_category_id", e.target.value)
                                 }}
                              >
                                 {
                                    foodCategory?.map((result, i) => {
                                       return (
                                          <MenuItem value={result._id} key={i} >
                                             {result.name}
                                          </MenuItem>
                                       )
                                    })
                                 }
                              </Select>
                              {errors.grocery_category_id && touched.grocery_category_id && <Typography color="error">{errors.grocery_category_id}</Typography>}
                           </FormControl>
                        </div>
                        <div className="col-lg-6">
                           <FormControl fullWidth className="mb-3">
                              <InputLabel id="demo-simple-select-label">From Menu</InputLabel>
                              <Select
                                 labelId="demo-simple-select-label"
                                 id="grocery_menu_id"
                                 name="grocery_menu_id"
                                 label="From Category"
                                 value={selectMenuId}
                                 onChange={(e) => {
                                    handleFoodMenuOnChange(e);
                                    setFieldTouched("grocery_menu_id", true)
                                    setFieldValue("grocery_menu_id", e.target.value)
                                 }}
                              >
                                 {
                                    groceryMenuData?.map((result, i) => {
                                       return (
                                          <MenuItem value={result._id} key={i} >
                                             {result.name}
                                          </MenuItem>
                                       )
                                    })
                                 }
                              </Select>
                              {errors.grocery_menu_id && touched.grocery_menu_id && <Typography color="error">{errors.grocery_menu_id}</Typography>}
                           </FormControl>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Name' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("name")}
                              />
                              {errors.name && touched.name && <Typography color="error">{errors.name}</Typography>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Price' name='price' type='number' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("price")} onChange={(e) => setPrice(e)}
                              />
                              {errors.price && touched.price && <Typography color="error">{errors.price}</Typography>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Discount' name='discount' type='number' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("discount")} onChange={(e) => setDiscount(e)}
                              />
                              {errors.discount && touched.discount && <Typography color="error">{errors.discount}</Typography>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Offer Price' name='offerPrice' type='number' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("offerPrice")} disabled
                              />
                              {errors.offerPrice && touched.offerPrice && <Typography color="error">{errors.offerPrice}</Typography>}
                           </div>
                        </div>
                        <div className="col-12">
                           <div className="form-group mb-4">
                              <TextField sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '3.5rem' } }} label='Description' multiline name='description' autoComplete='off' fullWidth
                                 {...getFieldProps("description")}
                              />
                              {errors.description && touched.description && <Typography color="error">{errors.description}</Typography>}
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Quantity' name='quantity' type='number' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("quantity")}
                              />
                              {errors.quantity && touched.quantity && <Typography color="error">{errors.quantity}</Typography>}
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-lg-6">
                              <ShowImage modalId={Id} profilePic={profilePic} showImage={showImage} folderName="groceryItem/" onRemoveFunc={() => { removeImage() }} />
                              <Button
                                 className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                                 variant="contained"
                                 component="label"
                                 style={{ "borderRadius": 5 }}
                              >
                                 {Id ? 'Change image' : 'Select Image'}
                                 <input
                                    hidden
                                    accept="image/*"
                                    onChange={(event) => {
                                       const files = event.target.files[0];
                                       if (files !== undefined) {
                                          setFlag('asd')
                                          handleProfilePicOnChange(files);
                                       }
                                    }}
                                    type="file"
                                 />
                              </Button>
                              <FormHelperText error>
                                 {errors.image}
                              </FormHelperText>
                              {/* {errors.image && touched.image && <Typography color="error">{errors.image}</Typography>} */}
                           </div>
                        </div>
                     </div>
                     <div className="col">
                        <div className="col-md-8 m-auto">
                           <LoadingButton
                              type='submit'
                              fullWidth
                              className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                              loading={buttonLoading}
                              loadingPosition="end"
                              variant="contained"
                           >
                              submit
                           </LoadingButton>
                        </div>
                     </div>
                  </Form>
               </FormikProvider>
            </DialogContent>
         </Dialog>
      </>
   )
}

export default GroceryItem